import buildUrl from '../utils/buildUrl';
import { baseUrl } from './baseUrl';
import { DicTypeId } from '../interfaces/DicTypeId';

interface IProps {
  type: DicTypeId;
  includeDeleted?: boolean;
  excludeIds?: string[] | number[] | number;
}

export const getDictionaryByType = ({ type, includeDeleted, excludeIds }: IProps) =>
  buildUrl({
    url: `${baseUrl}/gateway/v1/dictionaries/${type}`,
    searchParams: {
      includeDeleted: includeDeleted,
      excludeIds: excludeIds,
    },
  });

export const getDictionariesByType = (types: DicTypeId[]) =>
  buildUrl({
    url: `${baseUrl}/gateway/v1/dictionaries/`,
    searchParams: {
      type: types,
      includeDeleted: true,
    },
  });

export const getFullDictionariesByType = (types: DicTypeId[]) =>
  buildUrl({
    url: `${baseUrl}/dictionaries/dictionaries/`,
    searchParams: {
      type: types,
    },
  });
